import React, { useState } from "react";

const FAQs = ({ faqData: currentFaq }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (currentFaq && currentFaq?.isActive && currentFaq?.faqs?.length) ? (
    <div className="FAQs-section py-5">
      <div className="container">
        <div className="faq-container">
          <div className="section-header">
            <h3 className="text-center mb-3">Frequently Asked Questions</h3>
            <p className="section-subtitle">
              Find answers to common questions about our Microsoft cloud solutions
            </p>
          </div>

          <div className="faq-accordion">
            <div className="row">
              <div className="col-lg-6">
                {currentFaq?.faqs.map((faq, index) => (
                  index % 2 === 0 ? (
                    <div
                      key={index}
                      className={`faq-item ${activeIndex === index ? "active" : ""}`}
                    >
                      <div
                        className="faq-question"
                        onClick={() => toggleFaq(index)}
                      >
                        <h3 className="m-0">{faq.question}</h3>
                        <div className={`faq-icon pi pi-plus ${activeIndex === index ? "rotate" : ""}`} />
                      </div>

                      <div
                        className="faq-answer"
                        style={{
                          maxHeight:
                            activeIndex === index ? "unset" : "0px",
                        }}
                      >
                        <div className="faq-answer-content" dangerouslySetInnerHTML={{ __html: faq.answer }} />
                      </div>
                    </div>
                  ) : null
                ))}
              </div>
              <div className="col-lg-6">
                {currentFaq?.faqs.map((faq, index) => (
                  index % 2 !== 0 ? (
                    <div
                      key={index}
                      className={`faq-item ${activeIndex === index ? "active" : ""}`}
                    >
                      <div
                        className="faq-question"
                        onClick={() => toggleFaq(index)}
                      >
                        <h3 className="m-0">{faq.question}</h3>
                        <div className={`faq-icon pi pi-plus ${activeIndex === index ? "rotate" : ""}`} />
                      </div>

                      <div
                        className="faq-answer"
                        style={{
                          maxHeight:
                            activeIndex === index ? "unset" : "0px",
                        }}
                      >
                        <div className="faq-answer-content" dangerouslySetInnerHTML={{ __html: faq.answer }} />
                      </div>
                    </div>
                  ) : null
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default FAQs;
